export const useSxStyles = () => {
  return {
    root: {
      textAlign: 'center',
    },
    progress: {
      margin: '50px 0px',
    },
  };
};
